module.exports = __webpack_public_path__ + "img/vergnano-roasting.c99dc32f.jpg";